import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Pagination from "./../../../../shared/components/pagination";
import CustomExpandableTable from "../../../../shared/components/customExpandableTable";
import Loader from "../../../../shared/components/loader";
import AdminSettingsService from "../../../../adminsettings/services/adminsettings.service";
import CONSTANT from "../../../../shared/constants/constant";
import Report from '../../../../report/services/report.service';
import Util from "../../../../shared/util/util";
import MasterService from "../../../../masterdata/services/masterdata.service";
import Treeselect from "@riophae/vue-treeselect";
import CryptoJS from "crypto-js";
import VueElementLoading from 'vue-element-loading';
import TripServices from '../../../services/firstAndLastmilemanagement.service';
import DatePicker from 'vue2-datepicker';
import moment from 'moment';
import XLSX from 'xlsx';
export default {
  name: "PendingWaybills",
  components: {
    Pagination,
    Loader,
    Multiselect,
    CustomExpandableTable,
    Treeselect,
    DatePicker,
	VueElementLoading
  },
  data: function () {
    return {
      tableArr: [],
      selectedODAObj: "",
      type: "Pending Waybills",
      isLoading: false,
      Loader: false,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      offset: 0,
      hubaccessObjArray: [],
      hubids: null,
      motherhubArr: [],
      motherhubids: null,
      UpdateDTHMapping: "",
      actiontype: "",
      useremail: "",
      tableColumn: [
        "AWB",
        "MPS",
        "ClientRefNo",
        "Route Mode",
        "Booking Mode",
        "Client Name",
        "Origin",
        "Destination",
        "Phy Weight (kg)",
        "Vol Weight (kg)",
        "PDD Date",
		"Current Hub Inscan Date",	
        "Appointment Date",
        "Action",
      ],
      tableItems: [],
      selectedAWB: [],
      awberr: "",
      pageLimit: CONSTANT.PER_PAGE_HTD_DATA,
      isAllSelected: "",
      seletedAWB: [],
      selectedRemoveAWB: [],
      isAllAddedSelected: "",
      branchesselected: 0,
      markhtdModal: false,
      markhtdreasons: [],
      markhtdreason: null,
      shortcuts: false,
      htdreason: "",
      isActive: true,
      pendingdata: "",
      hubname: '',
      shipmentselected: 0,
      companyNamelist: [],
      ClientName: null,
      AWB: '',
      hubids: null,
      motherhubArr: [],
      motherhubids: null,
      shortcuts: false,
      appointmentDate: '',
      radDate: '',
      markhtdProgressModal: '',
      promiseAwbList: [],
      promiseresultstatus: [],
      popuptype: 0,
      Promiseinprogress: true,
      markhtdbtndisable: false,
      updateCounter: 0,
	  currenthubinscandate:'',
	  disabledHubInscandate:new Date(),
	  disabledAfter:new Date().setDate(new Date().getDate() + 30),
    controllingHub:[]
    };
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem(
      "cargoAutoaccessuserdata"
    );
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.createdby = userdetail.username;
    this.defaultHubID = userdetail.hubID[0];
    this.hubname = userdetail.currentHubName;
    this.hubid = userdetail.hubID[0];
    this.userid = userdetail.userid;
    this.useremail = userdetail.email;
	  await this.getPendingWaybills();
    this.getCompanyShortName();
    this.getHubAccessList();
    this.getmarkHTDShipments();
  },
  methods: {
	allowedappointmentDates(date) {
		var Difference_In_Time = date[1].getTime() - date[0].getTime(); 
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
		if(Difference_In_Days > 30){
			this.$alertify.error("Max 30 days can be selected");
			this.appointmentDate='';
		}
	},
	allowedinScanDates(date) {
		var Difference_In_Time = date[1].getTime() - date[0].getTime(); 
		var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
		if(Difference_In_Days > 30){
			this.$alertify.error("Max 30 days can be selected");
			this.currenthubinscandate='';
		}
	  },
    isIntegerOnly: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode == 13) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    select() {
      if (this.isAllSelected) {
        this.isAllSelected = 0;
      }
    },
    selectAll() {
      if (this.isAllSelected) {
        this.tableItems.forEach((item) => {
          if (this.selectedAWB.some((el) => el.AWB == item.AWB)) {
            return;
          } else {
            this.selectedAWB.push(item);
          }
        });
      } else {
        this.selectedAWB = this.selectedAWB.filter((item) => {
          if (this.tableItems.some((el) => el.AWB == item.AWB)) {
            return false;
          } else {
            this.selectedAWB.pop(item);
          }
        });
      }
    },
    selectRemove() {
      if (this.isAllAddedSelected) {
        this.isAllAddedSelected = 0;
      }
    },
    async getPendingWaybills() {
      this.isLoading = true;
      this.totalCount = 0;
      try {
        let inputPayload = {
          offset: this.offset,
          limit: this.pageLimit,
          type: "pending",
		  isexport:0
        };
		inputPayload.hubid = this.hubid
        if (this.AWB != null && this.AWB != '') {
          let awbnumbers = this.AWB.trim().split(/[\n,' ']+/)
          let awbarr = awbnumbers.filter(function (n) { return n !== "" });
          if (awbarr.length > 20) {
            this.$alertify.error("Maximum 20 AWB Allowed", "", "error");
          } else {
            inputPayload.awb = awbarr
          }
        }
        if (this.ClientName) {
          inputPayload.clientid = this.ClientName.id
        }
        if (this.hubids) {
          inputPayload.destinationhubid = this.hubids.hubid
        }
		if(this.currenthubinscandate[0]){
			inputPayload.currentfromdate = moment(this.currenthubinscandate[0]).format('YYYY-MM-DD')
			inputPayload.currenttodate =moment(this.currenthubinscandate[1]).format('YYYY-MM-DD')
		}
        if (this.appointmentDate[0]) {
          inputPayload.appointmentfromdate = moment(this.appointmentDate[0]).format('YYYY-MM-DD')
          inputPayload.appointmenttodate = moment(this.appointmentDate[1]).format('YYYY-MM-DD')
        }
        let result = await TripServices.getPendingEwaybillsList(
          inputPayload
        );
        if (result.data.code == 200) {
          this.totalCount = parseInt(result.data.data.count);
          this.tableArr = result.data.data.rows;
          this.controllingHub = result.data.data.controllinghub
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              id: el.id,
              AWB: el.parentawbno,
              MPS: el.totalmps,
              ClientRefNo: el.clientreferenceno,
              RouteMode: el.routemode,
              BookingMode: el.bookingmode,
              ClientName: el.businessaccountname,
              Originhubid: el.originhubid,
              Destinationhubid: el.finaldestinationid,
              Origin: el.originhubName,
              Destination: el.destinationhubName,
              PhyWt: el.physicalwt,
              VolWt: el.volumetricwt,
              PDDDate: el.pdd ? moment(el.pdd).format('YYYY-MM-DD') : null,
              AppointmentDate: el.appointmentdate ? moment(el.appointmentdate).format('YYYY-MM-DD') : null,
			  CurrentHubinscandate:el.lastmodifieddate ? moment(el.lastmodifieddate).format('YYYY-MM-DD'):null,
              clientid: el.clientid,
              clientbusinessaccountid: el.clientbusinessacountid,
            };
          });
        } else if(result.data.code == 409){
          this.controllingflag = true
          this.$emit("setcontrollingflag", this.controllingflag);
        }else {
          this.$alertify.error("No Shipment Found");
          this.tableItems = [];
        }
		this.AWB =''
		this.isLoading = false;
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1;
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit;
      this.selectedAWB = []
      this.isAllSelected = false;
      this.selectAll();
      this.getPendingWaybills();
    },
    async getmarkHTDShipments() {
      try {
        this.isLoading = true;
        let input = {}
        let result = await TripServices.getmarkHTDReason(input);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.htdreason = result.data.data;
          for (var i = 0; i < this.htdreason.length; i++) {
            this.markhtdreasons.push({
              id: this.htdreason[i].id,
              name: this.htdreason[i].name,
            });
          }
        } else {
          this.$alertify.error("Reason Not Added");
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async markHTDPendingShipments(data) {
      try {
        let dt = moment().tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
        this.Promiseinprogress = true;
        let inputPayload = {};
        let promiseArr = []
        for (let i = 0; i < data.length; i++) {
          let inputPayload = {};
          inputPayload.awb = data[i].AWB;
          inputPayload.mpscount = data[i].MPS;
          inputPayload.routemode = data[i].RouteMode;
          inputPayload.bookingmode = data[i].BookingMode;
          inputPayload.clientid = data[i].clientid;
          inputPayload.clientbusinessaccountid = data[i].clientbusinessaccountid;
          inputPayload.clientname = data[i].ClientName;
          inputPayload.originhubid = data[i].Originhubid;
          inputPayload.destinationhubid = data[i].Destinationhubid;
          inputPayload.currenthubid = this.hubid;
          inputPayload.physicalwt = data[i].PhyWt;
          inputPayload.volumetricwt = data[i].VolWt;
          inputPayload.type = "markhtd";
          inputPayload.comment = this.markhtdreason.name;
          inputPayload.lastmodifiedby = this.useremail;
          (inputPayload.pdddate = data[i].PDDDate),
          (inputPayload.appointmentdate = data[i].AppointmentDate);
          inputPayload.originhubname = data[i].Origin
          inputPayload.destinationhubname = data[i].Destination
          inputPayload.currenthubname = this.hubname,
          inputPayload.currenthubinscandate = dt
          this.promiseAwbList.push(data[i].AWB);
          this.promiseresultstatus.push({ awb: data[i].AWB, status: 'In Progress', message: 'In Progress' })
          this.markRemoveHTDApi(inputPayload)
          this.isLoading = false;
        }
        // this.closemarkhtd();
      } catch (error) {
        this.isLoading = false;
        console.log("Error --------", error);
      }
    },
    async markRemoveHTDApi(input) {
      try {
        let result = await TripServices.markRemoveHTD(input)
        for (let index = 0; index < this.promiseresultstatus.length; index++) {
          if (result.code == 200) {
            if (this.promiseresultstatus[index].awb == input.awb) {
              this.updateCounter = this.updateCounter + 1
              this.$set(this.promiseresultstatus, index, { awb: this.promiseresultstatus[index].awb, status: result.status, message: result.message });
            }
          } else {
            if (this.promiseresultstatus[index].awb == input.awb) {
              this.updateCounter = this.updateCounter + 1
              this.$set(this.promiseresultstatus, index, { awb: this.promiseresultstatus[index].awb, status: result.status, message: result.message });
            }
          }
          if (this.updateCounter == this.promiseresultstatus.length) {
            this.Promiseinprogress = false;
            this.getPendingWaybills();
          }
        }
      } catch (error) {
        for (let index = 0; index < this.promiseresultstatus.length; index++) {
          if (this.promiseresultstatus[index].awb == input.awb) {
            this.updateCounter = this.updateCounter + 1
            this.$set(this.promiseresultstatus, index, { awb: data[i].AWB, status: 'Failed', message: 'Internal server error.' });
            if (this.updateCounter == this.promiseresultstatus.length) {
              this.Promiseinprogress = false;
              this.getPendingWaybills();
            }
          }
        }
      }
    },

    async markHTDShipments() {  // slected awb and mark htd
      try {
        this.isLoading = true;
        if (this.markhtdreason) {
          if (this.popuptype == 1) {
            this.markHTDPendingShipments(this.pendingdata);
            this.markhtdbtndisable = true;
          } else if (this.popuptype == 2) {
            this.markHTDPendingShipments([this.pendingdata]);
            this.markhtdbtndisable = true;
          }
        } else {
          this.$alertify.error("Please select a reason");
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async markHTD(data, type) { // this f
      try {
        this.isLoading = true;
        this.popuptype = type
        this.markhtdModal = true;
        this.pendingdata = data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    closemarkhtd() {
      this.markhtdModal = false;
      this.markhtdbtndisable = false;
      this.resetmarkhtd();
    },
    resetmarkhtd() {
      this.pendingdata = ''
      this.markhtdreason = null;
      this.selectedAWB = []
      this.isAllSelected = false;
      this.updateCounter = 0
      this.promiseAwbList = [];
      this.promiseresultstatus = [];
      this.selectAll();
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].ClientShortName,
            'CompanyName': CompanyShortList[i].CompanyName
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getHubAccessList() {
      try {
        let InputPayload = {};
        this.isLoading = true;
			let response = await MasterService.GetHublist(InputPayload);
			if (response.data.code === 200) {
			  this.hubaccess = response.data.data.data;
			  for (var i = 0; i < this.hubaccess.length; i++) {
				this.hubaccessObjArray.push({
				  hubid: this.hubaccess[i].HubID,
				  hubname: this.hubaccess[i].HubName
				})
			  }
        if(this.controllingHub.length > 0 ){
          const filteredArray = this.hubaccessObjArray.filter(obj => this.controllingHub.includes(obj.hubid));
          this.hubaccessObjArray = filteredArray
        }
			}
			else {
			  this.$alertify.error(response.data.message);
			}
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
    resetFilter() {
      this.currentPage = 1;
      this.offset = 0;
      this.AWB = '';
      this.ClientName = null;
      this.hubids = '',
        this.appointmentDate = '';
      this.radDate = ''
	  this.currenthubinscandate = ''
      this.getPendingWaybills();
    },
    async onPageChange2(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.selectedAWB = []
      this.isAllSelected = false;
      this.selectAll();
      await this.getPendingWaybills();
    },
    async unselectHTDShipment(data) {
      this.selectedAWB = []
      this.isAllSelected = false;
      this.selectAll();
    },
    async DownloadPendingHTDData() {
      try {
        this.isLoading = true;
        let inputPayload = {
          offset: this.offset,
          limit: this.totalCount,
          type: "pending",
		    isexport:1
        };
		inputPayload.hubid = this.hubid
        if (this.AWB != null && this.AWB != '') {
          let awbnumbers = this.AWB.trim().split(/[\n,' ']+/)
          let awbarr = awbnumbers.filter(function (n) { return n !== "" });
          if (awbarr.length > 20) {
            this.$alertify.error("Maximum 20 AWB Allowed", "", "error");
            this.isLoading = false;
          } else {
            inputPayload.awb = awbarr
          }
        }
        if (this.ClientName) {
          inputPayload.clientid = this.ClientName.id
        }
        if (this.hubids) {
          inputPayload.destinationhubid = this.hubids.hubid
        }
		if(this.currenthubinscandate[0]){
			inputPayload.currentfromdate = moment(this.currenthubinscandate[0]).format('YYYY-MM-DD')
			inputPayload.currenttodate =moment(this.currenthubinscandate[1]).format('YYYY-MM-DD')
		}
        if (this.appointmentDate[0]) {
          inputPayload.appointmentfromdate = moment(this.appointmentDate[0]).format('YYYY-MM-DD')
          inputPayload.appointmenttodate = moment(this.appointmentDate[1]).format('YYYY-MM-DD')
        }
        let result = await TripServices.getPendingEwaybillsList(
          inputPayload
        );
        this.isLoading = false;
        if (result.data.code == 200) {
		  this.totalCount = parseInt(result.data.data.count);
          let tempdata = result.data.data.rows.map((el) => {
            return {
              'AWB': el.parentawbno,
              'MPS': el.totalmps,
              'ClientRefNo': el.clientreferenceno,
              'RouteMode': el.routemode,
              'BookingMode': el.bookingmode,
              'ClientName': el.businessaccountname,
              'Originhubid': el.originhubid,
              'Destinationhubid': el.finaldestinationid,
              'Origin': el.originhubName,
              'Destination': el.destinationhubName,
              'PhyWt': el.physicalwt,
              'VolWt': el.volumetricwt,
              'PDDDate': el.pdd ? moment(el.pdd).format('YYYY-MM-DD') : null,
			  'Current Hub Inscan Date': el.lastmodifieddate ? moment(el.lastmodifieddate).format('YYYY-MM-DD'):null,
              'AppointmentDate': el.appointmentdate ? moment(el.appointmentdate).format('YYYY-MM-DD') : null,
            };
          });
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data, 'data')
          XLSX.writeFile(wb, dt + '_HTDPendingdata.xlsx');
        } else {
          this.$alertify.error("No Data Found")
        }
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        this.isLoading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/htdawblevelmarking/pendingwaybills/pendingwaybills.component.js